import { Provider } from '@angular/core';
import { FavoritesDataHttpService } from './abstract';
import { FavoritesDataHttpServiceImpl } from './favorites-data-http.service';

export const FavoritesDataHttpProvider: Provider = {
	provide: FavoritesDataHttpService,
	useClass: FavoritesDataHttpServiceImpl,
};
